import { createTheme, ThemeOptions } from '@mui/material/styles';

import WsColors from '../WsColors';

export const lightTokens = {
  palette: {
    primary: {
      main: WsColors.TheBlues500,
    },
    secondary: {
      main: WsColors.TertiaryShades500,
    },
    error: {
      main: WsColors.Red500,
    },
    success: {
      main: WsColors.Green500,
    },
    background: {
      default: WsColors.TertiaryShades50,
    },
  },
  typography: {
    fontFamily: 'Manrope',
  },
  components: {
    MuiTypography: {
      variants: [
        {
          props: { variant: 'h5' },
          style: {
            fontSize: '18px',
            fontWeight: '700',
          },
        },
        {
          props: { variant: 'h6' },
          style: {
            fontSize: '16px',
            fontWeight: '700',
          },
        },
        {
          props: { variant: 'body1' },
          style: {
            fontSize: '14px',
            fontWeight: '400',
          },
        },
        {
          props: { variant: 'body2' },
          style: {
            fontSize: '12px',
            fontWeight: '400',
          },
        },
      ],
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          color: WsColors.TertiaryShades600,
          '& .MuiTabs-indicator': {
            backgroundColor: WsColors.TheBlues500,
          },
          '& .MuiTab-root.Mui-selected': {
            color: WsColors.TheBlues500,
            fontWeight: 'bold',
          },
          '.MuiTabs-scrollButtons': {
            width: '19px',
          },
        },
      },
    },
    MuiButton: {
      variants: [
        {
          props: { variant: 'outlined' },
          style: {
            minWidth: 'fit-content',
            color: WsColors.TheBlues500,
            textTransform: 'none',
            borderColor: WsColors.TheBlues500,
            '&:active': {
              borderColor: WsColors.TheBlues50,
              backgroundColor: WsColors.TheBlues50,
            },
            '&:hover': {
              borderColor: WsColors.TheBlues500,
              backgroundColor: WsColors.TheBlues50,
            },
          },
        },

        {
          props: { variant: 'text' },
          style: {
            minWidth: 'fit-content',
            color: WsColors.TheBlues500,
            textTransform: 'none',
            borderColor: WsColors.TheBlues500,
            '&:active': {
              backgroundColor: WsColors.TheBlues50,
            },
            '&:hover': {
              backgroundColor: WsColors.TheBlues50,
            },
          },
        },

        {
          props: { variant: 'contained' },
          style: {
            minWidth: 'fit-content',
            color: WsColors.White,
            textTransform: 'none',
            backgroundColor: WsColors.TheBlues500,
            borderColor: WsColors.TheBlues500,
            '&:active': {
              backgroundColor: WsColors.TheBlues600,
            },
            '&:hover': {
              backgroundColor: WsColors.TheBlues600,
            },
          },
        },

        {
          props: { variant: 'white' },
          style: {
            minWidth: 'fit-content',
            color: WsColors.White,
            textTransform: 'none',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: WsColors.White,
            '&:hover': {
              backgroundColor: 'transparent',
              borderColor: WsColors.White,
            },
          },
        },

        {
          props: { variant: 'black' },
          style: {
            minWidth: 'fit-content',
            color: WsColors.GenericRichBlack,
            textTransform: 'none',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: WsColors.White,
            '&:hover': {
              backgroundColor: 'transparent',
              borderColor: WsColors.White,
            },
          },
        },

        {
          props: { size: 'large' },
          style: {
            height: '40px',
            fontsize: '14px',
            fontWeight: '700',
          },
        },
        {
          props: { size: 'medium' },
          style: {
            height: '32px',
            fontsize: '12px',
            fontWeight: '600',
          },
        },
        {
          props: { size: 'small' },
          style: {
            height: '29px',
            fontsize: '12px',
            fontWeight: '600',
          },
        },
      ],
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: 28,
          height: 16,
          padding: 0,
          display: 'flex',
          borderRadius: 8,
        },
        switchBase: {
          padding: 2,
          '&.Mui-checked': {
            transform: 'translateX(12px)',
          },
        },
        track: {
          backgroundColor: WsColors.GreyBlack,
          boxSizing: 'border-box',
          bordRadius: 8,
          '.Mui-checked.MuiSwitch-colorPrimary + &': {
            opacity: 1.0,
            backgroundColor: WsColors.TheBlues500,
          },
        },
        thumb: {
          width: 12,
          height: 12,
          borderRadius: 6,
          backgroundColor: WsColors.White,
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: WsColors.TheBlues600,
          '&.Mui-checked': {
            color: WsColors.TheBlues600,
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '.MuiAutocomplete-tag': {
            backgroundColor: WsColors.TheBlues100,
            '&.MuiAutocomplete-tag': {
              backgroundColor: WsColors.White,
            },
          },
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          '&.MuiToggleButtonGroup-grouped': {
            borderRadius: '5px !important',
          },
          '&.MuiToggleButton-root': {
            backgroundColor: WsColors.TheBlues500,
            textTransform: 'none',
            borderColor: 'none',
            fontWeight: 'bold',
            color: WsColors.White,
            border: 'none',
            '&:hover': {
              backgroundColor: 'none',
              fontWeight: 'bold',
              borderRadius: 5,
            },
            '&.Mui-selected': {
              backgroundColor: WsColors.White,
              color: WsColors.TheBlues500,
              fontWeight: 'bold',
              boxShadow: '2px 2px 2px 2px' + WsColors.TheBlues500,
              borderRadius: 5,
            },
            '&.Mui-disabled': {
              backgroundColor: WsColors.TheBlues100,
              color: WsColors.White,
              fontWeight: 'bold',
              borderRadius: 5,
              '&.Mui-selected': {
                backgroundColor: WsColors.TertiaryShades100,
                color: WsColors.TheBlues300,
                fontWeight: 'bold',
                boxShadow: '2px 2px 2px 2px' + WsColors.GreyBlack,
                borderRadius: 5,
              },
            },
          },
        },
      },
    },
    MuiDataGrid: {
      defaultProps: {
        disableSelectionOnClick: true,
        sortingOrder: ['asc', 'desc'],
      },
    },
  },
};

const theme = createTheme(lightTokens as ThemeOptions);

export default theme;
